export default __webpack_public_path__ + "static/media/Sage's Sash of the Eldritch.71413f94.jpg";